export default "__VITE_ASSET__uhGAiXAR__"